<template>
    <div id="ppanel"
         :style="data.stylePpanel"
         :class="data.classPpanel"
    >
        <div id="content-wrapper"
             :style="data.styleContentWrapper"
        >
            <div class="heading"> {{ data.heading }}</div>
            <catalog ref="refCatalog"
                     :style="data.styleCategory"
                     v-show="pPanelState.activeMenu === config.reader.ppanel.menuCatalog"
            ></catalog>
            <tool ref="refTool"
                  :style="data.styleCategory"
                  v-show="pPanelState.activeMenu === config.reader.ppanel.menuTool"
            ></tool>
            <resources ref="refResources"
                       :style="data.styleCategory"
                        v-show="pPanelState.activeMenu === config.reader.ppanel.menuResources"
            ></resources>
        </div>
        <a id="btn-toggle-ppanel"
           class="hover-effect"
           href="#"
           @click.prevent="togglePpanel"
        >
            <img class="full-size" src="~images/btn_toggle_panel.png">
        </a>
        <div id="menu"
             v-show="pPanelState.isExpand"
           >
            <a href="#"
               :class="classIsMenuBtn(pPanelState.isCatalogEnabled, config.reader.ppanel.menuCatalog)"
               @click.prevent="setActiveMenu(config.reader.ppanel.menuCatalog)"
            >
                {{ i18n.t("label_content")}}
            </a>
            <a href="#"
               :class="classIsMenuBtn(pPanelState.isToolEnabled, config.reader.ppanel.menuTool)"
               @click.prevent="setActiveMenu(config.reader.ppanel.menuTool)"
            >
                {{ i18n.t("label_tools")}}
            </a>
            <a href="#"
               :class="classIsMenuBtn(pPanelState.isResourcesEnabled, config.reader.ppanel.menuResources)"
               @click.prevent="setActiveMenu(config.reader.ppanel.menuResources)"
            >
                {{ i18n.t("label_teaching_resources")}}
            </a>
            <a href="#"
               class="disabled"
               :class="classIsMenuBtn(pPanelState.isUploadedResourcesEnabled, config.reader.ppanel.menuIsUploadedResources)"
               @click.prevent="setActiveMenu(config.reader.ppanel.menuUploadedResources)"
            >
                {{ i18n.t("label_uploaded_resources") }}
            </a>
        </div>
    </div>
    <div id="mask"
          v-show="pPanelState.isExpand"
         @click="togglePpanel"
    >
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUnMounted, onUnmounted, onUpdated, watchEffect, watch, computed, nextTick, inject}  from "vue";
    import axios from 'axios'
    import qs from "qs";
    import config from "@/config/config.json";
    import {usePpanel}  from "@/modules/reader/ppanel/ppanel";
    import Catalog from "@/views/reader/ppanel/Catalog";
    import Tool from  "@/views/reader/ppanel/Tool";
    import Resources from  "@/views/reader/ppanel/Resources";
    import cssvar from '@/scss/_variables.scss';
    import {isTouchDevice} from "@/modules/utils/deviceUtils";

    const headerHeight = parseInt(cssvar.headerHeight)
    const footerHeight = parseInt(cssvar.footerHeight)
    const pPanelVerticalMargin = parseInt(cssvar.pPanelVerticalMargin)

    export default {
        components: {
            Catalog,
            Tool,
            Resources
        },
        setup(props, context) {

            const {pPanelState, togglePpanel, setActiveMenu, updateCategoryHeight} = usePpanel();
            const i18n = inject('i18n');

            const data = reactive({
                stylePpanel:computed(()=>{
                    return {
                        top:`${headerHeight + pPanelVerticalMargin}px`
                    }
                }),
                styleContentWrapper:computed(()=>{
                    return {
                        height:`${pPanelState.pPanelHeight}px`
                    }
                }),
                classPpanel:computed(()=>{
                   return {
                       expand: pPanelState.isExpand
                   }
                }),
                styleCategory:computed(()=>{
                    return {
                        height:`${pPanelState.categoryContentHeight}px`,
                    }
                }),
                heading:null
            })

            const refCatalog = ref(null);
            const refTool = ref(null);
            const refResources = ref(null);

            let startScrollPageY = {}
            let scrollTop = {};

            startScrollPageY[config.reader.ppanel.menuCatalog] = 0;
            startScrollPageY[config.reader.ppanel.menuTools] = 0;
            startScrollPageY[config.reader.ppanel.menuResources] = 0;

            scrollTop[config.reader.ppanel.menuCatalog] = 0;
            scrollTop[config.reader.ppanel.menuTools] = 0;
            scrollTop[config.reader.ppanel.menuResources] = 0;

            const windowOnResized = (e)=>{
                let scale = (isTouchDevice()) ? window.visualViewport.scale : 1;
                pPanelState.pPanelHeight = (window.innerHeight - headerHeight - footerHeight - 2 * pPanelVerticalMargin) * scale;
                updateCategoryHeight();
            }

            const classIsMenuBtn = (isEnabled, menu) => {
                return {
                    disabled: !isEnabled,
                    active: pPanelState.activeMenu === menu
                }
            }

            onMounted(()=>{

                if (!isTouchDevice()) {
                    window.addEventListener("resize", (e) => {
                        windowOnResized();
                    })
                }
                windowOnResized();
            });

            watchEffect(()=>{

                if (refCatalog.value && pPanelState.activeMenu === config.reader.ppanel.menuCatalog) {
                    data.heading = refCatalog.value.data.heading;
                }

                if (refTool.value && pPanelState.activeMenu === config.reader.ppanel.menuTool) {
                    data.heading = refTool.value.data.heading;
                }

                if (refResources.value && pPanelState.activeMenu === config.reader.ppanel.menuResources) {
                    data.heading = refResources.value.data.heading;
                }

            })

            onUpdated(()=>{
                updateCategoryHeight();
            })

            return {
                i18n,
                data,
                pPanelState,
                togglePpanel,
                setActiveMenu,
                classIsMenuBtn,
                updateCategoryHeight,
                refCatalog,
                refTool,
                refResources,
                config
            }
        }

    }

</script>

<style scoped lang="scss">

    $btn-toggle-panel-width:44px;

    .expand {
        transform: translate(500px,0);
    }

    #ppanel {
        /*width:538px;*/
        height:38px;
        position: fixed;
        display:flex;
        left:-500px;
        z-index: $zindex-ppanel;
        @include transition(transform,.3s);
    }

    #mask {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
        position: fixed;
        left: 0;
        top: 0;
        z-index:$zindex-ppanel-mask;
    }

    #menu {

        left: 538px;
        margin-top: 82px;
        margin-left: -$btn-toggle-panel-width;

        a {
            border-radius: 0 6px 6px 0;
            padding: 12px;
            font-size: 16px;
            display: block;
            margin: 2px 0;
            background:$color-primary-brighter;
            @include transition(background, .2s);
            color:$color-primary-deepest;
            font-weight:400;

            &:hover {
                background:$color-primary-bright;
                color:#fff;
            }

            &.active{
                background: $color-primary-deeper;
                color:#fff;
            }

            &.disabled {
                opacity: 1 !important;
                background:$grey;
                pointer-events:none !important;
                color:$text-color-primary;
            }
        }
    }

    #btn-toggle-ppanel {
        width:$btn-toggle-panel-width;
        height:38px;
        right:-6px;
    }

    #content-wrapper {
        width:500px;
        height:100%;
        border-radius:0 0 8px 0;
        border:2px solid $border-color-light;
        box-sizing: border-box;
        overflow:hidden;
        background:#fff;
        box-shadow: 0 7px 7px #666;

        .heading {
            background:$color-primary-light;
            color:$color-primary-deeper;
            font-size:18px;
            font-weight:400;
            padding:10px;
        }
    }

    @mixin set-mobile-width() {

        #ppanel {
            width:70%;
        }
    }

    @include responsive(mobile-tiny) {
        @include set-mobile-width;
    }

    @include responsive(mobile) {
        @include set-mobile-width;
    }


    @include responsive(mobile-large) {
        @include set-mobile-width;
    }

    @include responsive(mobile-mega) {
        @include set-mobile-width;
    }

    :deep(.ppanel-listing) {
        overflow-y:auto;
        overscroll-behavior: contain;
        font-size:18px;
    }

    :deep(.item) {
        border-top:1px solid $border-color-lightest;
        a {
            color:$text-color-primary;
            display:flex;
            padding:10px;
            transition: background 0.2s ease-in;
            align-items: center;
            line-height:1.4em;
            font-size:16px;

            &:hover{
                background:$color-ui-active;
            }
        }

        &:last-child {
            border-bottom:1px solid $border-color-lightest;
        }

        .item:last-child {
            border-bottom:none !important;
        }

    }

    :deep(.no-data) {
        color:$grey;
        text-align: center;
        margin:30px 0 0 0;
    }

</style>